export default {
  generateUUID: function(template) {
    let dt = new Date().getTime()
    return template.replace(/[xy]/g, function(c) {
      var r = (dt + Math.random() * 16) % 16 | 0
      dt = Math.floor(dt / 16)
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
    })
  }
}
